(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3549],{

/***/ 3549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content079": function() { return /* binding */ Content079; },
  "default": function() { return /* binding */ Content079_Content079; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/components/widgets/content/Content079/Content079.module.scss
var Content079_module = __webpack_require__(24920);
var Content079_module_default = /*#__PURE__*/__webpack_require__.n(Content079_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/utils/formatDate/formatTime.js
var formatTime = __webpack_require__(58475);
// EXTERNAL MODULE: ./src/components/widgets/content/Content079/Item/Item.module.scss
var Item_module = __webpack_require__(62597);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content079/Item/Item.jsx







var Item = function(param) {
    var item = param.item;
    var ref, ref1;
    var locale = (0,router.useRouter)().locale;
    var ref2 = (0,react.useMemo)(function() {
        var day = new Date(item.eventDate).getDate();
        var month = new Date(item.eventDate).getMonth() + 1;
        return {
            day: day,
            month: month
        };
    }, [
        item.eventDate
    ]), day = ref2.day, month = ref2.month;
    var t = (0,translations/* useTranslation */.$)().t;
    var formatCounter = function(number) {
        return number > 9 ? number : "0".concat(number);
    };
    var eventStart = (0,react.useMemo)(function() {
        return (0,formatTime/* formatTime */.m)(item.eventDate, locale);
    }, [
        item.eventDate,
        locale
    ]);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Item_module_default()).item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
            directory: "events",
            slug: item.slug,
            className: (Item_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Item_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (Item_module_default()).category,
                                uppercase: true,
                                children: (ref3 = (ref = item.eventCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref3 !== void 0 ? ref3 : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (Item_module_default()).title,
                                color: "dark",
                                appearance: "bold",
                                children: item.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Item_module_default()).bottom,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Item_module_default()).details,
                                children: [
                                    (item === null || item === void 0 ? void 0 : item.eventType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                        color: "dark",
                                        appearance: "bold",
                                        className: (Item_module_default()).type,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (Item_module_default()).icon,
                                                name: "message"
                                            }),
                                            t(item.eventType)
                                        ]
                                    }),
                                    eventStart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                        color: "dark",
                                        appearance: "bold",
                                        className: (Item_module_default()).time,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (Item_module_default()).icon,
                                                name: "clock"
                                            }),
                                            eventStart
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Item_module_default()).date,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                        className: (Item_module_default()).day,
                                        color: "brand",
                                        appearance: "bold",
                                        plain: true,
                                        children: formatCounter(day)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                        className: (Item_module_default()).month,
                                        color: "brand",
                                        plain: true,
                                        children: [
                                            "/",
                                            formatCounter(month)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content079/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content079/Content079.jsx









var Content079 = function(param) {
    var payload = param.payload;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("079", payload.id);
    var t = (0,translations/* useTranslation */.$)().t;
    var events = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "events",
            defaultValue: []
        }, 
    ]).events;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.caption) !== null && ref1 !== void 0 ? ref1 : "";
    var slicedItems = (0,react.useMemo)(function() {
        return events.slice(0, 4);
    }, [
        events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content079_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content079_module_default()).blocks,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content079_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                as: "h3",
                                className: (Content079_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                value: description,
                                className: (Content079_module_default()).description,
                                color: "dark"
                            })
                        ]
                    }),
                    events.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Content079_module_default()).items,
                        children: slicedItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                item: item
                            }, item.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                        appearance: "bold",
                        children: t("empty_events")
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Content079_Content079 = (Content079);


/***/ }),

/***/ 58475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ formatTime; }
/* harmony export */ });
var formatTime = function(date, locale) {
    if (date) {
        return new Intl.DateTimeFormat(locale, {
            hour: "2-digit",
            minute: "2-digit"
        }).format(new Date(date));
    }
    return null;
};


/***/ }),

/***/ 24920:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content079_wrapper___QK40","top":"Content079_top___c0RI","title":"Content079_title__DNbuA","description":"Content079_description__yXUZV","items":"Content079_items__nUCf0"};

/***/ }),

/***/ 62597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__lBQiZ","wrapper":"Item_wrapper__xXcOx","bottom":"Item_bottom__1WlmY","block":"Item_block__0yKPa","type":"Item_type__XVTh2","time":"Item_time__ITsw2","title":"Item_title__5_RiN","category":"Item_category__oaEfN","date":"Item_date__umorq","day":"Item_day__yci_j","month":"Item_month__1r6u4","icon":"Item_icon__8XYA_"};

/***/ })

}]);